import React from 'react';
import { stats } from '../data/content';
export function StatsBar() {
  return <section className="w-full bg-brand py-10 sm:py-14" data-id="element-156" data-mp="1tarjq9bipqkw">
      <dl className="mx-auto grid max-w-6xl grid-cols-2 gap-y-8 px-5 md:grid-cols-4 md:gap-y-0" data-id="element-157" data-mp="1tb9pbwk2lh5h">
        {stats.map((stat, index) => <div key={stat.label} className={`px-4 text-center ${index > 0 ? 'md:border-l md:border-white/15' : ''}`} data-id="element-158" data-mp="1jcanoxxq2lrz" data-mpi={index}>
            <dt className="sr-only" data-id="element-159" data-mp="1ef26p0ob8nsb">{stat.label}</dt>
            <dd data-id="element-160" data-mp="19lg27vsavq7l">
              <span className="block font-display text-3xl font-black text-lime sm:text-4xl" data-id="element-161" data-mp="19kxzqhf1ofr8">
                {stat.value}
              </span>
              <span className="mt-1 block text-[10px] font-bold uppercase tracking-[0.16em] text-white/70 sm:text-xs" data-id="element-162" data-mp="10lsxp149y4ab">
                {stat.label}
              </span>
            </dd>
          </div>)}
      </dl>
    </section>;
}